const types = Object.freeze({
  VEHICLE: "DeviceType.VEHICLE",
  PERSONAL: "DeviceType.PERSONAL",
  isValid: value => !!Object.values(types).find(type => type === value)
});

export default types;
